import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import AddObserverRequest from '../../../projects/task/i-service/models/observer/request/AddObserverRequest';
import RemoveObserverRequest from '../../../projects/task/i-service/models/observer/request/RemoveObserverRequest';
import TaskIdRequest from '../../../projects/task/i-service/models/observer/request/TaskIdRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import UserIdResponse from '../../../projects/task/i-service/models/observer/response/UserIdResponse';

export default class TaskObserverService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	AddObserverAsyncEvent = new Events<WsResponseModelT<Boolean>>();
	RemoveObserverAsyncEvent = new Events<WsResponseModelT<Boolean>>();
	GetObserversByTaskIdEvent = new Events<WsResponseModelT<UserIdResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('TaskObserverService', 'AddObserverAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.AddObserverAsyncEvent.trigger(res);
		});
		webApiService.on('TaskObserverService', 'RemoveObserverAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveObserverAsyncEvent.trigger(res);
		});
		webApiService.on('TaskObserverService', 'GetObserversByTaskId', 'Main', (res: WsResponseModelT<UserIdResponse>) => {
			self.GetObserversByTaskIdEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Метод добавления наблюдателя
	 */
	async AddObserverAsync(request: AddObserverRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskObserverService',
			Method: 'AddObserverAsync',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление наблюдателя из задачи
	 */
	async RemoveObserverAsync(request: RemoveObserverRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskObserverService',
			Method: 'RemoveObserverAsync',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка пользователей подписанных на задачу
	 */
	async GetObserversByTaskId(request: TaskIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskObserverService',
			Method: 'GetObserversByTaskId',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Метод добавления наблюдателя
	 */
	async addObserverAsyncAsync(request: AddObserverRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskObserverService',
				Method: 'AddObserverAsync',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление наблюдателя из задачи
	 */
	async removeObserverAsyncAsync(request: RemoveObserverRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskObserverService',
				Method: 'RemoveObserverAsync',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка пользователей подписанных на задачу
	 */
	async getObserversByTaskIdAsync(request: TaskIdRequest): Promise<UserIdResponse> {
		return new Promise<UserIdResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskObserverService',
				Method: 'GetObserversByTaskId',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<UserIdResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UserIdResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}